import { contrastRatio } from '@yola/yola-palette-generator';
import increaseColorPointByStep from '../utils/increase-color-point-by-step';
import increaseColorPointByRatio from '../utils/increase-color-point-by-ratio';
import increaseOpacity from '../utils/increase-opacity';

const inputDefaultLight = (params, { condition }) => {
  const { targetColor, backgroundColor, backgroundColorPalette, blackColor } = params;
  const fallback = {
    rule: 'input.borderColor.default.light',
    params,
  };
  if (condition(contrastRatio(backgroundColor, targetColor))) {
    const increasedBackgroundColor = increaseColorPointByStep({
      targetColor: backgroundColor,
      targetColorPalette: backgroundColorPalette,
      step: 1,
      fallback,
    });

    return increaseColorPointByRatio({
      targetColor: increasedBackgroundColor,
      targetColorPalette: backgroundColorPalette,
      backgroundColor,
      condition,
      fallback,
    });
  }
  return increaseOpacity({
    targetColor: blackColor,
    backgroundColor,
    opacity: 0.01,
    condition,
    fallback,
  });
};

export default inputDefaultLight;
